import React from "react";
import "../../../css/Components/DesignSystem/Buttons.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const ButtonYellow = ({ buttonText, onClick }) => {
  const [clicked, setClicked] = useState(false);
  const navigate = useNavigate();

  // const handleClick = () => {
  //   navigate(link); // Navigate to the provided link
  // };

  return (
    <div
      className={`Button-Brand3 ${clicked ? "clicked" : ""}`}
      onClick={() => {
        setClicked(!clicked); // Toggle the clicked state
        // handleClick();
        onClick && onClick();
      }}
    >
      <div className="Button-Text">{buttonText}</div>
    </div>
  );
};

export default ButtonYellow;
